import React from 'react';
import ResultadoListaPartidos from '../consulta/ResultadoListaPartidos.js';
import { NombreEquipoTorneo } from '../funciones/FuncionesEquipo.js';
import * as FuncionesFecha from '../funciones/FuncionesFecha.js';
import styles from './PartidosFechaEtapa.module.css';

const PartidosFechaEtapa = (props) => {
  const fecha = props.fecha;
  const partidos = props.partidos;
  const torneo = props.torneo;

  let partidosFecha = [];
  let equiposLibres = [];
  if (fecha && partidos) {
    for (const partido of partidos) {
      if (partido.nroFecha === Number(fecha)) {
        if (partido.equipoLibre) {
          const nombreLocal =
            partido.equipoLocal && partido.equipoLocal.nombre
              ? partido.equipoLocal.nombre
              : 'Equipo desconocido';
          equiposLibres = [...equiposLibres, nombreLocal];
        } else {
          partidosFecha = [...partidosFecha, partido];
        }
      }
    }
  }

  // Agrupar partidos por zona
  const partidosPorZona = {};
  const zonasOrdenadas = [];

  partidosFecha.forEach((partido) => {
    const zona = partido.zona || null;
    if (!partidosPorZona[zona]) {
      partidosPorZona[zona] = [];
      zonasOrdenadas.push(zona);
    }
    partidosPorZona[zona].push(partido);
  });

  // Verificar si hay zonas definidas
  const hayZonas =
    zonasOrdenadas.length > 1 || (zonasOrdenadas.length === 1 && zonasOrdenadas[0] !== null);

  const obtenerTituloZona = (zona) => {
    if (!zona) return null;
    if (zona === 'X') return 'Interzonal';
    return `Zona ${zona}`;
  };

  const onPartidoElegido = (partidoElegido) => {
    props.onPartidoElegido(partidoElegido);
  };

  return (
    <table className={`${styles.tabla_partidos}`}>
      <thead>
        <tr>
          <th>Día</th>
          <th>Local</th>
          <th>Result</th>
          <th>Visitante</th>
        </tr>
      </thead>
      <tbody>
        {hayZonas
          ? // Si hay zonas, mostrar partidos agrupados por zona
            zonasOrdenadas.map((zona) => (
              <React.Fragment key={zona || 'sin-zona'}>
                {zona && zona !== '-' && (
                  <tr>
                    <td colSpan="4" className={`${styles.tituloZona}`}>
                      {obtenerTituloZona(zona)}
                    </td>
                  </tr>
                )}
                {partidosPorZona[zona].map((partido) => (
                  <tr key={partido.id}>
                    <td className={`${styles.fecha}`}>
                      {FuncionesFecha.CamposToFechaCorta(
                        partido.anioPartido,
                        partido.mesPartido,
                        partido.diaPartido
                      )}
                    </td>
                    <td className={`${styles.equipo}`}>
                      {torneo
                        ? NombreEquipoTorneo(partido.equipoLocal, torneo)
                        : partido.equipoLocal.nombre}
                    </td>
                    <td className={`${styles.result}`}>
                      <ResultadoListaPartidos
                        id={partido.id}
                        onPartidoElegido={onPartidoElegido}
                        local={partido.resultadoLocal}
                        visitante={partido.resultadoVisitante}
                      />
                    </td>
                    <td className={`${styles.equipo}`}>
                      {partido.equipoVisitante &&
                        (torneo
                          ? NombreEquipoTorneo(partido.equipoVisitante, torneo)
                          : partido.equipoVisitante.nombre)}
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))
          : // Si no hay zonas, mostrar partidos normalmente
            partidosFecha.map((partido) => (
              <tr key={partido.id}>
                <td className={`${styles.fecha}`}>
                  {FuncionesFecha.CamposToFechaCorta(
                    partido.anioPartido,
                    partido.mesPartido,
                    partido.diaPartido
                  )}
                </td>
                <td className={`${styles.equipo}`}>
                  {torneo
                    ? NombreEquipoTorneo(partido.equipoLocal, torneo)
                    : partido.equipoLocal.nombre}
                </td>
                <td className={`${styles.result}`}>
                  <ResultadoListaPartidos
                    id={partido.id}
                    onPartidoElegido={onPartidoElegido}
                    local={partido.resultadoLocal}
                    visitante={partido.resultadoVisitante}
                  />
                </td>
                <td className={`${styles.equipo}`}>
                  {partido.equipoVisitante &&
                    (torneo
                      ? NombreEquipoTorneo(partido.equipoVisitante, torneo)
                      : partido.equipoVisitante.nombre)}
                </td>
              </tr>
            ))}
        {equiposLibres &&
          equiposLibres.map((nombre, index) => (
            <tr key={`libre-${index}`}>
              <td colSpan="4" className={`${styles.equipo}`}>
                {`Libre: ${nombre}`}
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default PartidosFechaEtapa;
